<template>
  <v-card class="info-card">
    <mf-loading :loader="['ativos-geo-status', 'inativos-geo-status']">
      <v-card-text class="pb-0">
        <v-layout>
          <v-flex>
            <span class="subheading secondary-text">Clientes no mapa</span>
          </v-flex>
          <v-spacer />
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon small color="cinza-0">help</mf-icon>
              </span>
            </template>
            <span>{{ porcentagemClientesResolvidos | localeString(1) | percent }} com coordenadas</span>
            <br />
            <span>{{ (clientesSemEndereco + clientesPendentes) | localeString(0) }} clientes sem coordenadas</span>
          </v-tooltip>
        </v-layout>
        <v-layout class="mb-2">
          <v-flex>
            <span class="display-2 primary-text">{{ clientesResolvidos | localeString(0) }}</span>
            <v-tooltip v-if="clientesResolvidos > 250000" bottom max-width="300">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <mf-icon small color="#D98202">report</mf-icon>
                </span>
              </template>
              <span
                >Devido ao grande volume de dados, estamos exibindo uma amostra representativa dos clientes no mapa. Esta seleção aleatória de 20% dos pontos
                nos permite manter a performance do navegador. Os dados mostrados oferecem uma ideia da distribuição de clientes, mas não incluem todos devido
                ao volume elevado.</span
              >
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-text class="pa-7 pt-2">
        <v-layout row>
          <v-flex xs6>
            <p class="px-2caption mb-0 secondary-text">Ativos</p>
            <div v-if="showAtivos">
              <p class="subheading mb-0 primary-text">{{ ativosStatus && ativosStatus['NUM_CLIENTES_RESOLVIDOS'] | localeString(0) }}</p>
              <p class="subheading mb-0 secondary-text">
                +{{ ativosStatus && (ativosStatus['NUM_CLIENTES_PENDENTES'] + ativosStatus['NUM_CLIENTES_NAO_RESOLVIVEIS']) | localeString(0) }} s/ coord
              </p>
            </div>
            <p v-else class="subheading mb-0 primary-text">-</p>
          </v-flex>
          <v-flex xs6>
            <p class="caption mb-0 secondary-text">Inativos recentes</p>
            <div v-if="showAtivos">
              <p class="subheading mb-0 primary-text">{{ inativosStatus && inativosStatus['NUM_CLIENTES_RESOLVIDOS'] | localeString(0) }}</p>
              <p class="subheading mb-0 secondary-text">
                +{{ inativosStatus && (inativosStatus['NUM_CLIENTES_PENDENTES'] + inativosStatus['NUM_CLIENTES_NAO_RESOLVIVEIS']) | localeString(0) }} s/ coord
              </p>
            </div>
            <p v-else class="subheading mb-0 primary-text">-</p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </mf-loading>
  </v-card>
</template>

<script>
import includes from 'lodash/includes'

export default {
  props: {
    ativosStatus: Object,
    inativosStatus: Object,
    toggle: Array,
  },
  computed: {
    showAtivos() {
      return includes(this.toggle, 'ativos')
    },
    showInativos() {
      return includes(this.toggle, 'inativos')
    },
    clientesResolvidos() {
      return this.dadosCliente('NUM_CLIENTES_RESOLVIDOS')
    },
    clientesSemEndereco() {
      return this.dadosCliente('NUM_CLIENTES_NAO_RESOLVIVEIS')
    },
    clientesPendentes() {
      return this.dadosCliente('NUM_CLIENTES_PENDENTES')
    },
    totalClientes() {
      return this.dadosCliente('NUM_CLIENTES_TOTAL')
    },
    porcentagemClientesResolvidos() {
      return (this.clientesResolvidos / this.totalClientes) * 100
    },
  },
  methods: {
    dadosCliente(property) {
      if (!this.ativosStatus || !this.inativosStatus) return ''
      if (this.showAtivos && this.showInativos) {
        return this.ativosStatus[property] + this.inativosStatus[property]
      } else if (!this.showAtivos && !this.showInativos) {
        return 0
      } else {
        if (this.showAtivos) {
          return this.ativosStatus[property]
        } else {
          return this.inativosStatus[property]
        }
      }
    },
  },
}
</script>

<style lang="scss">
.info-card {
  position: absolute !important;
  left: 0;
  top: 0;
  left: 20px;
  margin-top: 20px;
  z-index: 3;
  width: 300px;
  height: 184px;
  border-radius: 5px;
}
</style>
